import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { Image, OverlayTrigger, Tooltip } from 'react-bootstrap';
import images from '../constants/images';
import { SeeByT } from '../types/SeeByT';
import { randomId } from '../utils';

export type ILineItemSeeByProps = {
    index: number
    item?: SeeByT
}

const LineItemSeeBy: React.FC<ILineItemSeeByProps> = (props) => {
    const uniqeId = randomId()
    /**
     *
     */
    const getLastSee = (item: SeeByT) => {
        if (_.isArray(item.see_gmt)) {
            const lastSee = item.see_gmt[props.item.see_gmt.length - 1]
            return moment(lastSee).isValid() && moment.utc(lastSee).local().format('MM/DD/YYYY h:mm:ss A')
        }
        return '';
    }
    return (
        <div key={props.index} style={{cursor:"pointer"}}>
            <OverlayTrigger
                key={props.index}
                placement={"top"}
                overlay={
                    <Tooltip id={`tooltip-${props.index}-${uniqeId}`}>
                        {`${props.item.user.firstName} ${props.item.user.lastName}`}
                        <br />
                        last seen
                        <br />
                        {getLastSee(props.item)}
                    </Tooltip>
                }
            >
                <Image style={{
                    height: 40,
                    padding: 2,
                    width: 40
                }} src={props.item.user.profilePic ? props.item.user.profilePic : images.noProfilePic} />
            </OverlayTrigger>
        </div>
    );
}

export default LineItemSeeBy